import request from 'axios'

export default async (header) => {
  const response = await request(header)
  if(response.status === 200) {
    return response.data
  } else {
    return new Error('Your get some errer by this URL').message
  }
}